import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgLoaderComponent } from "../../../ui-kit/images/svg-loader/svg-loader.component";
import { isIndependentNonOwner } from 'app/utils/membership-utils';

@Component({
  selector: 'app-membership-block',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './membership-block.component.html',
  styleUrls: ['./membership-block.component.scss']
})
export class MembershipBlockComponent {
  @Input() membership: any;
  @Input() canEdit: boolean = true;
  @Output() handleEdit = new EventEmitter;
  @Output() handleDelete = new EventEmitter;

  get canShowEdit(): boolean {
    if (!this.canEdit) {
      return false;
    }
    return !isIndependentNonOwner(this.membership);
  }

  onClickEdit() {
    if (!this.canShowEdit) {
      return;
    }
    this.handleEdit.emit(this.membership);
  }

  onClickDelete() {
    this.handleDelete.emit(); // TODO: Wire later
  }
}
